import httpHelper from "../helpers/http_helper";

const authenticateService = {
    logIn: async function (data) {
        return await httpHelper.post("/RestApi/Service/SignIn082020", data);
    },
    getSignInData: async function () {
        return await httpHelper.post("/RestApi/Service/SignUpData");
    },
    signUp: async function (data) {
        return await httpHelper.post("/RestApi/Service/SignUp", data);
    },
    passwordRecovery: async function (data) {
        return await httpHelper.post("/RestApi/Service/RecoveryPassword", data);
    },
    changePassword: async function (data) {
        return await httpHelper.post("/RestApi/Service/ChangePassword", data);
    },
    home: async function () {
        return await httpHelper.post("/RestApi/Service/Home032020");
    }
}

export default authenticateService;